import { z } from 'zod';

export const ProfileSchema = z.object({
  firstName: z.string().max(50).optional(),
  lastName: z.string().max(50).optional(),
});

export type Profile = z.infer<typeof ProfileSchema>;
